import { createSlice } from "@reduxjs/toolkit";
import { getOneRoom, getRoomsForBooking , getRoomsItems} from "./thunk";

const initialState = {
  room: null,
  roomsItems: [],
  roomsForBooking: [],
  loading: false,
  error: null,
};

const roomSlice = createSlice({
  name: "roomSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoomsForBooking.pending, (state) => {
        state.loading = true;
        state.roomsForBooking = [];
      })
      .addCase(getRoomsForBooking.fulfilled, (state, action) => {
        state.loading = false;
        const rooms = Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
          ? action.payload
          : [];
        state.roomsForBooking = rooms.map((room) => ({
          ...room,
          isBusy: true,
        }));
      })
      .addCase(getRoomsForBooking.rejected, (state, action) => {
        state.loading = false;
        state.roomsForBooking = [];
        state.error = action.error.message;
      });
    builder
      .addCase(getRoomsItems.pending, (state) => {
        state.loading = true;
        state.roomsItems = [];
      })
      .addCase(getRoomsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.roomsItems = action.payload?.data;
      })
      .addCase(getRoomsItems.rejected, (state, action) => {
        state.loading = false;
        state.roomsItems = [];
        state.error = action.error.message;
      });
  
    builder
      .addCase(getOneRoom.pending, (state) => {
        state.loading = true;
        state.room = null;
      })
      .addCase(getOneRoom.fulfilled, (state, action) => {
        state.loading = false;
        const roomData = action.payload?.data || action.payload;
        state.room = roomData ? { ...roomData, isBusy: true } : null;
      })
      .addCase(getOneRoom.rejected, (state, action) => {
        state.loading = false;
        state.room = null;
        state.error = action.error.message;
      });
  },
});

export default roomSlice.reducer;
